/**
 * Pagination constants for the Users feature tables.
 *
 * @module features/users/constants/pagination
 */

/** Default number of rows per page */
export const DEFAULT_PAGE_SIZE = 10;

/** Options displayed in the page-size selector */
export const PAGE_SIZE_OPTIONS = ['5', '10', '20', '50', '100'] as const;
